import React, { Component } from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import { ConnectedRouter } from 'connected-react-router'
import {Layout, ConfigProvider} from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import {history} from "./store";
import {fetchAuthSessionApi, loginApi, logoutApi, AUTH_EXPIRED_EVENT} from "./common/api";
import NativeList from "./views/native-list";
import NativeLogDetail from "./views/native-log-detail";
import WebList from "./views/web-list";
import WebLogDetail from "./views/web-detail";
import Sider from "./common/components/Sider/Sider";
import LoginPage from "./views/login";
import AccountManagement from "./views/account-management";
import "antd/dist/antd.css";
import "./app.scss";

// antd 组件文案（分页器 "条/页"、日期面板等）与 moment 的星期/月份统一用中文
moment.locale("zh-cn");

class App extends Component {
  state = {
    authChecked: false,
    authenticated: false,
    currentUser: null,
    loginLoading: false,
    loginError: ""
  };

  componentDidMount() {
    window.addEventListener(AUTH_EXPIRED_EVENT, this.handleAuthExpired);
    this.checkSession();
  }

  componentWillUnmount() {
    window.removeEventListener(AUTH_EXPIRED_EVENT, this.handleAuthExpired);
  }

  componentDidCatch(error, errorInfo) {
    console.log(error);
  }

  render() {
    const {authChecked, authenticated, currentUser, loginLoading, loginError} = this.state;
    if (!authChecked) {
      return <div className="auth-loading" />;
    }
    if (!authenticated) {
      return <LoginPage loading={loginLoading} error={loginError} onLogin={this.handleLogin} />;
    }
    return (
      <ConfigProvider locale={zhCN}>
      <ConnectedRouter history={history}>
        <>
          <Layout style={{height: "100%"}}>
            <Sider currentUser={currentUser} onLogout={this.handleLogout}/>
            <div className="app">
              <Switch>
                <Redirect exact from="/" to="/native-list"/>
                <Route exact path="/native-list" component={NativeList}/>
                <Route exact path="/native-log-detail" component={NativeLogDetail}/>
                <Route exact path="/web-list" component={WebList}/>
                <Route exact path="/web-detail" component={WebLogDetail}/>
                <Route exact path="/users" render={() => (
                  this.isAdmin() ? <AccountManagement currentUser={currentUser}/> : <Redirect to="/native-list"/>
                )}/>
              </Switch>
            </div>
          </Layout>
        </>
      </ConnectedRouter>
      </ConfigProvider>
    );
  }

  checkSession = () => {
    fetchAuthSessionApi()
      .then(data => {
        this.setState({
          authChecked: true,
          authenticated: Boolean(data && data.authenticated),
          currentUser: data && data.authenticated ? data : null
        });
      })
      .catch(() => {
        this.setState({
          authChecked: true,
          authenticated: false,
          currentUser: null
        });
      });
  };

  handleLogin = (username, password) => {
    this.setState({
      loginLoading: true,
      loginError: ""
    });
    loginApi(username, password)
      .then(data => {
        this.setState({
          authenticated: true,
          currentUser: data,
          loginLoading: false,
          loginError: ""
        });
      })
      .catch(error => {
        this.setState({
          authenticated: false,
          currentUser: null,
          loginLoading: false,
          loginError: error && error.msg ? error.msg : "登录失败"
        });
      });
  };

  handleLogout = () => {
    logoutApi().finally(() => {
      this.setState({
        authenticated: false,
        currentUser: null,
        loginError: ""
      });
    });
  };

  handleAuthExpired = () => {
    this.setState({
      authenticated: false,
      currentUser: null,
      loginError: "登录已过期，请重新登录"
    });
  };

  isAdmin = () => {
    const { currentUser } = this.state;
    return currentUser && currentUser.role === "admin";
  };
}

export default App;
